import axios from '../shared/axios';
import * as events from './events';

export function get(paymentbatchid) {
    return axios.get(`/api/PaymentBatch/Get`, { params: { paymentbatchid } });
}

export function batchCreateDrafts(data) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/PaymentBatch/BatchCreateDrafts`, data)
            .then(result => {
                events.onNotification_CREATED();
                resolve(result);
            })
            .catch(error => reject(error));
    });
}

export function batchGetDrafts(paymentbatchid) {
  return axios.get(`/api/PaymentBatch/BatchGetDrafts?paymentbatchid=${paymentbatchid}`);
}

export function batchNotify(data, contractid, paymentbatchid) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/PaymentBatch/BatchNotify`, data, { params: { contractid, paymentbatchid } })
            .then(result => {
                events.onNotification_COMMUNICATED();
                resolve(result);
            })
            .catch(error => reject(error));
    });
}

export function getRegisterList(contractid, notificationtype) {
    return axios.get(`/api/PaymentBatch/RegisterList`, { params: { contractid, notificationtype } });
}

export function importPaymentCertificates(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.post(`/api/PaymentBatch/Import`, data);
            events.onNotification_CREATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function deletePaymentCertificateDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.delete(`/api/PaymentBatch/BulkDeleteDraft`, { data: data });
            events.onNotification_DELETED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function communicatePaymentCertificateDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.put(`/api/PaymentBatch/BulkCommunicate`, data);
            events.onNotification_COMMUNICATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}